// src/pinball/tables/ClassicArcadeTable.ts - Classic Arcade theme configuration

import { TableThemeConfig } from '../types';

export const ClassicArcadeTable: TableThemeConfig = {
  id: 'classic-arcade',
  name: 'Classic Arcade',
  description: 'A traditional pinball table with bumpers, ramps, and drop targets.',
  previewImage: '',
  width: 400,
  height: 800,

  elements: [
    // Pop bumpers (top area)
    {
      id: 'pop_bumper_1',
      type: 'pop_bumper',
      position: { x: 160, y: 200 },
      properties: { radius: 20, restitution: 1.2, activeImpulse: 300, pointValue: 100, color: '#ff4444' },
    },
    {
      id: 'pop_bumper_2',
      type: 'pop_bumper',
      position: { x: 235, y: 200 },
      properties: { radius: 20, restitution: 1.2, activeImpulse: 300, pointValue: 100, color: '#ff4444' },
    },
    {
      id: 'pop_bumper_3',
      type: 'pop_bumper',
      position: { x: 200, y: 260 },
      properties: { radius: 20, restitution: 1.2, activeImpulse: 300, pointValue: 100, color: '#ff4444' },
    },
    // Bumpers (mid area)
    {
      id: 'bumper_1',
      type: 'bumper',
      position: { x: 140, y: 370 },
      properties: { radius: 15, restitution: 1.3, pointValue: 50, color: '#ffaa00' },
    },
    {
      id: 'bumper_2',
      type: 'bumper',
      position: { x: 255, y: 370 },
      properties: { radius: 15, restitution: 1.3, pointValue: 50, color: '#ffaa00' },
    },
    // Slingshots
    {
      id: 'slingshot_left',
      type: 'slingshot',
      position: { x: 120, y: 620 },
      properties: { width: 40, height: 40, restitution: 1.2, pointValue: 10, color: '#00cc00' },
    },
    {
      id: 'slingshot_right',
      type: 'slingshot',
      position: { x: 270, y: 620 },
      properties: { width: -40, height: 40, restitution: 1.2, pointValue: 10, color: '#00cc00' },
    },
    // Drop target bank (left side)
    {
      id: 'drop_target_1',
      type: 'drop_target',
      position: { x: 80, y: 400 },
      properties: { width: 25, pointValue: 500, group: 'bank_left', groupIndex: 0, color: '#ff00ff' },
    },
    {
      id: 'drop_target_2',
      type: 'drop_target',
      position: { x: 80, y: 430 },
      properties: { width: 25, pointValue: 500, group: 'bank_left', groupIndex: 1, color: '#ff00ff' },
    },
    {
      id: 'drop_target_3',
      type: 'drop_target',
      position: { x: 80, y: 460 },
      properties: { width: 25, pointValue: 500, group: 'bank_left', groupIndex: 2, color: '#ff00ff' },
    },
    // Drop target bank (right side)
    {
      id: 'drop_target_4',
      type: 'drop_target',
      position: { x: 320, y: 400 },
      properties: { width: 25, pointValue: 500, group: 'bank_right', groupIndex: 0, color: '#00ffff' },
    },
    {
      id: 'drop_target_5',
      type: 'drop_target',
      position: { x: 320, y: 430 },
      properties: { width: 25, pointValue: 500, group: 'bank_right', groupIndex: 1, color: '#00ffff' },
    },
    {
      id: 'drop_target_6',
      type: 'drop_target',
      position: { x: 320, y: 460 },
      properties: { width: 25, pointValue: 500, group: 'bank_right', groupIndex: 2, color: '#00ffff' },
    },
    // Targets
    {
      id: 'target_center',
      type: 'target',
      position: { x: 200, y: 150 },
      properties: { width: 30, pointValue: 250, color: '#ffffff' },
    },
    // Spinner
    {
      id: 'spinner_1',
      type: 'spinner',
      position: { x: 170, y: 320 },
      properties: { width: 30, pointValue: 25, color: '#aaaaff' },
    },
    // Ramp
    {
      id: 'ramp_left',
      type: 'ramp',
      position: { x: 120, y: 500 },
      properties: {
        pointValue: 5000,
        path: [
          { x: 120, y: 500 },
          { x: 100, y: 300 },
          { x: 150, y: 150 },
        ],
        color: '#44ff44',
      },
    },
    {
      id: 'ramp_right',
      type: 'ramp',
      position: { x: 280, y: 500 },
      properties: {
        pointValue: 5000,
        path: [
          { x: 280, y: 500 },
          { x: 300, y: 300 },
          { x: 250, y: 150 },
        ],
        color: '#44ff44',
      },
    },
    // Lanes
    {
      id: 'lane_left',
      type: 'lane',
      position: { x: 50, y: 100 },
      properties: { pointValue: 1000, path: [{ x: 50, y: 100 }, { x: 50, y: 200 }], color: '#ffff00' },
    },
    {
      id: 'lane_center',
      type: 'lane',
      position: { x: 200, y: 80 },
      properties: { pointValue: 1000, path: [{ x: 180, y: 80 }, { x: 220, y: 80 }], color: '#ffff00' },
    },
    {
      id: 'lane_right',
      type: 'lane',
      position: { x: 350, y: 100 },
      properties: { pointValue: 1000, path: [{ x: 350, y: 100 }, { x: 350, y: 200 }], color: '#ffff00' },
    },
    // Orbit
    {
      id: 'orbit_1',
      type: 'orbit',
      position: { x: 200, y: 120 },
      properties: {
        pointValue: 3000,
        path: [
          { x: 60, y: 300 },
          { x: 50, y: 100 },
          { x: 200, y: 60 },
          { x: 350, y: 100 },
          { x: 340, y: 300 },
        ],
        color: '#ff8800',
      },
    },
  ],

  flippers: [
    {
      id: 'flipper_left',
      side: 'left',
      pivot: { x: 130, y: 720 },
      length: 60,
      restAngle: Math.PI / 6,       // 30 degrees below horizontal
      activeAngle: -Math.PI / 6,    // 30 degrees above horizontal
      activationTime: 50,
      returnTime: 80,
    },
    {
      id: 'flipper_right',
      side: 'right',
      pivot: { x: 270, y: 720 },
      length: 60,
      restAngle: Math.PI - Math.PI / 6,   // 150 degrees (mirrored)
      activeAngle: Math.PI + Math.PI / 6,  // 210 degrees (mirrored)
      activationTime: 50,
      returnTime: 80,
    },
  ],

  plunger: {
    position: { x: 375, y: 750 },
    laneWidth: 30,
    laneHeight: 100,
    maxLaunchSpeed: 3000,
    chargeTime: 1500,
  },

  drain: {
    position: { x: 200, y: 780 },
    width: 100,
  },

  outlanes: [
    { id: 'outlane_left', side: 'left', path: [{ x: 30, y: 650 }, { x: 30, y: 780 }] },
    { id: 'outlane_right', side: 'right', path: [{ x: 370, y: 650 }, { x: 370, y: 780 }] },
  ],

  inlanes: [
    { id: 'inlane_left', side: 'left', path: [{ x: 80, y: 650 }, { x: 100, y: 700 }] },
    { id: 'inlane_right', side: 'right', path: [{ x: 320, y: 650 }, { x: 300, y: 700 }] },
  ],

  walls: [
    // === PLAYFIELD BOUNDARY ===
    { id: 'wall_left', start: { x: 20, y: 20 }, end: { x: 20, y: 780 }, restitution: 0.5 },
    // Top wall spans full width including over the lane (ball curves under it)
    { id: 'wall_top', start: { x: 20, y: 20 }, end: { x: 395, y: 20 }, restitution: 0.5 },
    // Right wall (outer lane boundary)
    { id: 'wall_right', start: { x: 395, y: 20 }, end: { x: 395, y: 780 }, restitution: 0.5 },

    // === LAUNCHER LANE ===
    // Lane guide: inner wall separating lane from playfield
    // Has a ONE-WAY GAP at top (y:20 to y:60) — ball enters lane from bottom,
    // exits into playfield at top by going LEFT over the guide
    { id: 'wall_plunger_left', start: { x: 350, y: 300 }, end: { x: 350, y: 780 }, restitution: 0.3 },

    // === BOTTOM AREA ===
    { id: 'wall_guide_left', start: { x: 20, y: 780 }, end: { x: 130, y: 740 }, restitution: 0.4 },
    { id: 'wall_guide_right', start: { x: 350, y: 780 }, end: { x: 270, y: 740 }, restitution: 0.4 },

    // === TOP-RIGHT ARCH (larger curve to redirect ball from lane into playfield) ===
    { id: 'wall_arch_1', start: { x: 393, y: 60 }, end: { x: 390, y: 45 }, restitution: 0.7 },
    { id: 'wall_arch_2', start: { x: 390, y: 45 }, end: { x: 383, y: 32 }, restitution: 0.7 },
    { id: 'wall_arch_3', start: { x: 383, y: 32 }, end: { x: 372, y: 24 }, restitution: 0.7 },
    { id: 'wall_arch_4', start: { x: 372, y: 24 }, end: { x: 358, y: 21 }, restitution: 0.7 },
    { id: 'wall_arch_5', start: { x: 358, y: 21 }, end: { x: 340, y: 25 }, restitution: 0.7 },
    { id: 'wall_arch_6', start: { x: 340, y: 25 }, end: { x: 325, y: 35 }, restitution: 0.7 },
  ],

  scoring: {
    comboWindow: 5000,
    comboMultipliers: [1, 1.5, 2, 2.5, 3, 4, 5],
    endOfBallBonusBase: 5000,
    jackpotValue: 50000,
  },

  jackpotCondition: {
    type: 'all_ramps',
    requiredElements: ['ramp_left', 'ramp_right', 'orbit_1'],
    description: 'Complete both ramps and the orbit for JACKPOT!',
  },

  multiballCondition: {
    type: 'target_bank',
    requiredElements: ['drop_target_1', 'drop_target_2', 'drop_target_3', 'drop_target_4', 'drop_target_5', 'drop_target_6'],
    ballCount: 3,
    description: 'Complete both drop target banks for MULTIBALL!',
  },

  theme: {
    backgroundColor: '#1a0033',
    playfieldColor: '#2d1b4e',
    wallColor: '#8844cc',
    ballColor: '#cccccc',
    flipperColor: '#ff6600',
    fontFamily: '"Press Start 2P", monospace',
    darkModeOverrides: {
      backgroundColor: '#0a0015',
      playfieldColor: '#1a0d2e',
    },
  },
};
